import Services from './Services';
import Config from '../config';

const PermissionsModel = {
    my_permissions: () => {
        return Services.getApi(Config.getAuthBasePath_v2() + '/my-permissions');
    },
};

export default PermissionsModel;
